<template>
    <div>
        <input
            type="text"
            class="
              w-full rounded border border-gray-300 p-4 font-caption text-base focus-outline-only

              placeholder:font-caption
            "
            :placeholder="$t('TYPE_YOUR_TEXT_HERE')"
            :maxlength="allowedNumberOfCharacters"
            v-model="text"
            aria-labelledby="customTextLabel"
            @focus="openKeyboard"
            @blur="closeKeyboard"
        />
        <div
            v-if="validationError"
            class="my-[8px] text-red"
        >
            {{ $t('VALIDATION_ERROR') }}
        </div>
        <div
            v-if="!validationError && !valid"
            class="my-[8px] text-red"
        >
            <span v-if="justAdded">{{ $t('VALIDATION_REVIEW_JUST_ADDED') }}</span>
            <span v-else>{{ $t('VALIDATION_REVIEW') }}</span>
        </div>
        <div class="mt-[8px] flex font-sans text-sm font-normal text-gray-dark">
            <div>
                {{ numberOfRemainingCharacters }}
            </div>&nbsp;
            <div>
                {{ $t('CHARACTERS_REMAINING') }}
            </div>
        </div>
    </div>
</template>

<script>
    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        props: {
            value: String,
            controller: Object,
            selectedOption: Object,
            valid: Boolean,
            justAdded: Boolean,
        },

        emits: ['input', 'error'],

        data() {
            return {
                text: '',
                lastAcceptedText: '',
                validationError: false,
                changeCounter: 0,
                debounceTimeout: null,
            };
        },

        computed: {
            allowedNumberOfCharacters() {
                return +(this.selectedOption?.custom['personalization-limit'] ?? '0');
            },

            numberOfRemainingCharacters() {
                return this.allowedNumberOfCharacters - this.text.length;
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },

        watch: {
            text(newValue, oldValue) {
                this.selectText(newValue, oldValue);
            },

            value() {
                if (this.value !== this.text) {
                    this.text = this.value;
                    this.lastAcceptedText = this.value;
                }
            },

            validationError() {
                if (this.validationError) {
                    this.$emit('error');
                }
            },
        },

        mounted() {
            this.text = this.value;
            this.lastAcceptedText = this.value;
        },

        methods: {
            async selectText(newValue) {
                if (this.debounceTimeout) {
                    clearTimeout(this.debounceTimeout);
                }

                this.changeCounter += 1;

                const currentChange = this.changeCounter;

                // Debounce the validation.
                this.debounceTimeout = setTimeout(async () => {
                    try {
                        // If user typed something, abort this validation.
                        if (currentChange !== this.changeCounter) {
                            return;
                        }

                        let reviewResult = {
                            hasProfanity: false,
                        };

                        if (newValue.length > 0) {
                            reviewResult = await this.controller.reviewText(newValue);
                        }

                        // If another change occurred during the review, also abort.
                        if (currentChange !== this.changeCounter) {
                            return;
                        }

                        if (!reviewResult.hasProfanity && !reviewResult.reviewRecommended) {
                            // Which placement?
                            const placement = this.controller.findComponentPlacement(this.selectedOption.code);

                            // Commit changes.
                            const updateResult = await this.controller.updatePersonalization(placement.code, newValue, {
                                preview: true,
                            });

                            // If another change occurred during update, abort
                            if (currentChange !== this.changeCounter) {
                                return;
                            }

                            if (updateResult.accepted) {
                                if (updateResult.acceptedAs != null) {
                                    this.text = updateResult.acceptedAs;
                                }

                                this.$emit('input', {
                                    controller: this.controller,
                                    placement,
                                    text: this.text,
                                });

                                this.lastAcceptedText = this.text;
                                this.validationError = false;
                            } else {
                                // Revert to last accepted text if not accepted.
                                this.text = this.lastAcceptedText;
                                // This is not a content error.
                                this.validationError = false;
                            }
                        } else {
                            // Revert if profanity found.
                            // this.text = this.lastAcceptedText;
                            this.validationError = true;
                        }
                    // eslint-disable-next-line no-unused-vars
                    } catch (error) {
                        // this.text = this.lastAcceptedText;
                        this.validationError = true;
                    }
                }, 300);
            },

            openKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(true);
                }
            },

            closeKeyboard() {
                if (this.isMobile) {
                    this.appStore.toggleKeyboard(false);
                }
            },
        },
    };
</script>
